/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Paper, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { CheckCircle } from "@mui/icons-material";
import { Location } from 'history'
import { FC, useCallback, useEffect, useMemo, useState } from "react"
import { Prompt, useHistory, useLocation } from "react-router-dom";
import { DEFAULT_PROJETO } from "src/components/projetos/constants";
import { VerticaisManager, paths } from "src/components/vendas/VerticaisManager";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { TabContent } from "src/framework/components/navigations/tabs/TabContent";
import { TabControl } from "src/framework/components/navigations/tabs/TabControl";
import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { distribuidores$, revendas$ } from "src/store/global.store";
import { formState$ } from "src/store/vendas/projetos/store";
import theme from "src/theme/light";
import { Anexos } from "./Anexos";
import { InformacoesProjeto } from "./InformacoesProjeto";
import { setVendedorInternoModalStatus } from "src/store/vendas/projetos/actions";
import DefaultLayout from "../edicao/layouts/DefaultLayout";
import { salvarProjeto } from "../utils/salvarProjeto";
import { projetoSalvoComSucessoDialog } from "../utils/projetoSalvoComSucessoDialog";
import { authUser$ } from "src/framework/components/navigations/MenuUser";
import { ExtraInfoUsuario } from "src/providers/cadastros/ContaProvider/types";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { LoginStore } from "src/framework/store/LoginStore";
import { ProjetoTipoType } from "../types";

export type TabName = 'informacoes' | 'anexos'

interface TabProps {
    name: TabName;
    label: string;
    done: boolean;
    disabled: boolean
}

const useStyles = makeStyles({
    tabIcon: {
      marginRight: 8,
      fontSize: 22
    }
})

const manager: VerticaisManager = new VerticaisManager(paths, api, apiNoLoading);

const ProjetoVertical: FC = () => {

  const classes = useStyles();
  const history = useHistory<{ allowAccess?: boolean; noReset?: boolean; done?: boolean; tipo?: ProjetoTipoType }>();
  const location = useLocation<{allowAccess?: boolean}>()
  const verticalState = useObservable(formState$);
  const distribuidorsState = useObservable(distribuidores$);
  const revendasState = useObservable(revendas$);
  const _standAlone = LocalStorage.get("solar.standAlone", true);
  const authUser = useObservable<ExtraInfoUsuario | undefined>(authUser$)
  const permissoes = useObservable(LoginStore.permissoes) || [];

  const [errorState, setErrorState] = useState<string[]>([]);
  const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<any>(null)
  const [formState, setFormState] = useState<typeof verticalState>(null);
  const [tab, setTab] = useState('informacoes')

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const canNavigate = useCallback((promptLocation: Location | null = null)=>{
    const allowedLocations = ['/novo$', '/edicao$']
    const loc = (promptLocation || history.location) as Location<{ done: boolean; noReset: boolean }>
    return loc.state?.noReset || loc.state?.done || allowedLocations.some(item => {
      return loc.pathname.match(new RegExp(item))
    })
  },[history.location])

  const paramsPersonalizadoOff = useMemo(() => {
    return history.location.state?.tipo?.includes('personalizado_offgrid');
  }, [history]);

  const paramsPersonalizadoHibrido = useMemo(() => {
    return history.location.state?.tipo?.includes('personalizado_hibrido');
  }, [history]);

  useEffect(() => {
    if (paramsPersonalizadoOff && formState?.tipo === 'personalizado' && formState?.segmento?.includes('off')) {
      formState.tipo = "vertical";
      formState.segmento = "distribuicao_offgrid";
      setFormState(formState)
    }
  },[paramsPersonalizadoOff, formState])

  useEffect(()=>{
    if (paramsPersonalizadoHibrido && formState?.tipo === 'personalizado' && formState?.codigo_venda?.includes('HIBRI')) {
      formState.tipo = "vertical";
      formState.segmento = "distribuicao_ongrid";
      setFormState(formState)
    }
  },[paramsPersonalizadoHibrido, formState])

  useEffect(() => {
    return () => {
      if (!canNavigate()) {
        formState$.next(DEFAULT_PROJETO)
      }
    }
  },[canNavigate, history])

  useEffect(()=>{
    // Limpa estado da rota
    window.history.replaceState({}, document.title)
  },[location, location.state])
  
  useEffect(()=>{
    // Evita usuário acessar fluxo de criação sem passar pelo formulário inicial..
    const { allowAccess = false } = location.state || {}
    if (!allowAccess) {
      DEFAULT_PROJETO.segmento = 'vertical_ongrid'
      DEFAULT_PROJETO.tipo = 'vertical'
      formState$.next(DEFAULT_PROJETO)
      history.push("/projetos", { done: true })
    }
  },[history, location])

  const init = useCallback(()=>{
    const _distribuidorRevendaUsuario: any = LocalStorage.get("solar.userExtraInfo", true)
    setDistribuidorRevendaUsuario(_distribuidorRevendaUsuario)

  }, [])

  const anexosTabIsDisabled = useMemo((): { status: boolean, tooltipMessage?: string } => {
    if (formState?.solicitacao?.limitacao_observacao?.length < 20) return { status: true, tooltipMessage: "As observações devem ter no mínimo 20 caracteres para prosseguir." }
    return { status: false }
  },[formState?.solicitacao?.limitacao_observacao])

  const finishProjectButtonIsDisabled = useMemo(() => {
    return formState?.solicitacao?.unidade_consumidora && !formState?.anexos?.length
  }, [formState])

  const tabs = useMemo<TabProps[]>(()=>{
    return [
      {
        name: 'informacoes',
        label: 'Informações do Projeto',
        done: !anexosTabIsDisabled.status,
        disabled: false,
      },
      {
        name: 'anexos',
        label: 'Anexos',
        done: !finishProjectButtonIsDisabled,
        disabled: anexosTabIsDisabled.status,
      }
    ]
  },[anexosTabIsDisabled.status, finishProjectButtonIsDisabled])

  useEffect(() => {
    
    setFormState(verticalState)
    init()
  }, [verticalState, init]);

  useEffect(() => {
    if (distribuidorRevendaUsuario && formState) {
      if (!distribuidorRevendaUsuario.isIntelbras) {
        formState.distribuidor_id = distribuidorRevendaUsuario?.distribuidor_id;

        const distribuidores = distribuidores$.getValue().data
        const distribuidorIdx = distribuidores.findIndex((d) => d.id === formState.distribuidor_id)
        if (distribuidorIdx > -1) {
          formState.distribuidor = distribuidores[distribuidorIdx];
        }

        if (distribuidorRevendaUsuario?.revenda_id) {
          formState.revenda_id = distribuidorRevendaUsuario?.revenda_id;
          const revendas = revendas$.getValue().data;
          const revendaIdx = revendas.findIndex((r) => r.id === formState.revenda_id)
          if (revendaIdx > -1) {
            formState.revenda = revendas[revendaIdx];
          }
        }
        setFormState(formState)
      }
    }
  }, [distribuidorRevendaUsuario, distribuidorsState, revendasState]);

  const save = useCallback(async(afterSave?: (response: IDataResponse) => void, updatedFormState: any = {})=>{
    const state = { ...formState, ...updatedFormState };
    await salvarProjeto(manager, state.id, state, authUser).then(response => {
      if (typeof afterSave === 'function') afterSave(response)  
    })
  }, [formState])

  const afterSave = useCallback((response: IDataResponse) => {
    const successStatus = [STATUS_CODE.OK, STATUS_CODE.CREATED]
    if (successStatus.includes(response.statusCode)) {
      projetoSalvoComSucessoDialog(response.data[0].codigo_venda, history, { onlyConfirm: _standAlone, tipoProjeto: formState?.tipo })
    }
  }, [history, formState?.tipo])

  const onFinish = useCallback(async (updatedState: any = {})=>{
    await save((resp) => afterSave(resp), updatedState)
  }, [afterSave, save])

  const beforeSave = useCallback(() => {
    const withPermission = PermissionUtil.can(PermissionUtil.PERMISSION_VENDEDORES_LISTAGEM, permissoes);
    if (withPermission && !formState.isEdit) {
      setVendedorInternoModalStatus(true, (vendedor) => {
        const state = {
          ...formState,
          vendedor_interno: vendedor
        }

        setFormState(state)
        onFinish(state)
      })
    } else {
      onFinish()
    }
  },[formState, onFinish, permissoes])

  const renderContent = useCallback((name: TabName)=>{
    const contents: {[index: string]: React.ReactNode} = {
      informacoes: (
        <InformacoesProjeto
          onClickNext={() => setTab('anexos')}
          nextTabIsDisabled={anexosTabIsDisabled}
          onChangeValue={(newState) => setFormState({ ...newState })}
          onChangeError={(newErrorState) => setErrorState(newErrorState)}
          errorState={errorState}
          formState={formState}
          onClickBack={() => {
            if (formState?.isEdit) {
              history.push(`/projetos/${formState.id}/edicao`, { noReset: true })
              return
            }

            let url = '/projetos';
            if (paramsPersonalizadoOff && formState?.tipo === 'personalizado' && formState?.segmento?.includes('off')) {
              url += '?tipo=personalizado_offgrid'
            }

            history.push(url, { noReset: true })
          }}
        />
      ),
      anexos: (
        <Anexos
          onClickNext={beforeSave}
          finishProjectButtonIsDisabled={finishProjectButtonIsDisabled}
          onChangeValue={(newState) => setFormState({ ...newState })}
          onChangeError={(newErrorState) => setErrorState(newErrorState)}
          errorState={errorState}
          formState={formState}
          onClickBack={() => setTab('informacoes')}
        />
      ),
    }
    return contents[name]
  },[formState, finishProjectButtonIsDisabled, history, beforeSave, errorState, anexosTabIsDisabled, paramsPersonalizadoOff])

  return (
    <>
      <Paper elevation={0} className="tab-header">
        <TabControl indicatorColor="primary" onChangeTab={setTab} currentTabName={tab}>
          {tabs.map(item => (
            <TabContent
              disabled={item.disabled}
              name={item.name}
              visible={true}
              label={
                <Box display={isMobile ? "none" : "flex"} justifyContent={"center"} alignItems="center">
                    <CheckCircle htmlColor={item.done ? theme.palette.primary.dark : 'unset'} className={classes.tabIcon} />
                    <span>{item.label}</span>    
                </Box>
                    }>
                      <DefaultLayout>
                        {renderContent(item.name)}
                      </DefaultLayout>
            </TabContent>
          ))}
        </TabControl>
      </Paper>
      <Prompt message={(location) => {
        if (canNavigate(location)) return true;
        return `Deseja cancelar a ${formState?.isEdit ? 'edição' : 'criação'} do projeto?`
      }}/>
    </>
  )
}

export { ProjetoVertical }